import {RepositoryFactory} from '@/api/factory/repositoryFactory'
import {get} from 'lodash-es'
const ExamMonitorGroup = RepositoryFactory.get('examMonitorGroup')

const state = {
  items: [],
  count: 0,
  item: {},
}

const actions = {
  async fetchItems({commit}, params = {}) {
    const res = await ExamMonitorGroup.fetch(params)
    commit('setItems', get(res, 'data', []))
  },
  async countItems({commit}, params = {}) {
    const res = await ExamMonitorGroup.count(params)
    commit('setCount', get(res, 'data', 0))
  },
  removeItem(_, id) {
    return ExamMonitorGroup.remove(id)
  },
  createItem(_, payload = {}) {
    return ExamMonitorGroup.create(payload)
  },
  async fetchOneItem({commit}, id) {
    const res = await ExamMonitorGroup.fetchOne(id)
    commit('setItem', get(res, 'data', {}))
  },
  async fetchSubmissionReport(_, payload = {}) {
    const res = await ExamMonitorGroup.fetchSubmissionReport(payload)
    return get(res, 'data', [])
  },
  async fetchGroupStatReport(_, payload = {}) {
    const res = await ExamMonitorGroup.fetchGroupStatReport(payload)
    return get(res, 'data', [])
  },
  async unblockSubmission(_, {id}) {
    return ExamMonitorGroup.unblockSubmission(id)
  },
  async fetchCourses(_, params = {}) {
    const res = await ExamMonitorGroup.fetchCourses(params)
    return get(res, 'data', [])
  },
  async fetchGroups(_, params = {}) {
    const res = await ExamMonitorGroup.fetchGroups(params)
    return get(res, 'data', [])
  },
}
const mutations = {
  setItems(state, payload) {
    state.items = payload
  },
  setCount(state, payload) {
    state.count = payload
  },
  setItem(state, payload) {
    state.item = payload
  },
}
const getters = {
  items: state => state.items,
  count: state => state.count,
  item: state => state.item,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
